type InvitationCopyInput = {
  inviterName?: string | null;
  serverName?: string | null;
  workspaceName?: string | null;
  link: string;
  language?: string | null;
};

function nonEmpty(value?: string | null) {
  return value?.trim() || undefined;
}

export function formatWorkspaceInvitationCopyText({
  inviterName,
  serverName,
  workspaceName,
  link,
  language,
}: InvitationCopyInput) {
  // The server name is the explicit instance fallback for historical links
  // without a persisted inviter display name.
  const inviter = nonEmpty(inviterName) ?? nonEmpty(serverName) ?? 'AFFiNE';
  const workspace = nonEmpty(workspaceName) ?? 'Workspace';

  if (language?.toLowerCase().startsWith('zh')) {
    return `邀请您加入 ${inviter} 的 Workspace ${workspace}，访问此链接接受邀请：${link}`;
  }

  return `${inviter} invited you to join Workspace ${workspace}. Accept the invitation at: ${link}`;
}

export function formatInvitationExpiry(value?: string | null) {
  if (!value) {
    return '';
  }

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '' : date.toLocaleString();
}
